module.exports = {"Retirement1":{"daobanList":[{"title":"1:是否办理企业职工领取养老保险待遇资格认证","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、社会保障卡","state":"支持容缺处理"},{"name":"2、台湾通行证","state":"支持容缺处理"},{"name":"3、港澳通行证","state":"支持容缺处理"},{"name":"4、定居国护照","state":"支持容缺处理"},{"name":"5、居民身份证","state":"支持容缺处理"},{"name":"6、个人委托书（通过委托认证方式的）","state":"必要"},{"name":"7、单位（社区）证明资料（通过单位（社区）申报认证方式的）","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdr-1.json
// module id = 1291
// module chunks = 0